module.exports = __webpack_public_path__ + "static/media/shareDailyGraph.8e6eebdd.png";